<template>
  <div>
  <header class="head-wrap-tv" style="height: 180px;">
    <div class="header-title" style="height: 30px;">
      <img class="title-icon-tv" src="../../static/dj-logo.png" alt="">
      <div class="date-wrap">
        <a style="color: black;">{{ date }}</a>
        <a style="color: black;">|</a>
        <a style="color: black;">{{ status }}</a>
      </div>
    </div>
    <div class="head-prompt" style="height: 30px; margin-top: 120px">
      <div class="optional" @click="handleSelfSelectInOther">
        <img class="optional-img" src="../../static/img.png" alt="">
        <a class="optional-text">自选</a>
      </div>
    </div>
<!--    <div class="table-title" style="height: 50px;">-->
<!--      <div class="main-trs" style="border-top: 1px solid #444;">-->
<!--        <div class="t-th">商品</div>-->
<!--        <div class="t-th">回购</div>-->
<!--        <div class="t-th">销售</div>-->
<!--        <div class="t-th">高/低</div>-->
<!--      </div>-->
<!--    </div>-->
  </header>

  <el-dialog :visible.sync="GLOBAL.dialogOpenOther" class="dialog-wrap" width="90%">
    <div class="dialog-container">
      <h3 class="dialog-title">
        <div class="optional">
          <img class="optional-img" src="../../static/select.jpg" alt="" style="margin-left: 42%">
          <a class="optional-text">自选</a>
        </div>
      </h3>
      <div class="dialog-content">
        <div class="optional-item" :class="{ active: GLOBAL.selectMapOther.every(item => {return item.state;})}" @click="onClickOptionalItemInOther('all')" style="font-size: 18px; font-weight: bolder">全部</div>
        <div class="optional-item" :class="{ active: item.state }" style="font-size: 18px; font-weight: bolder" v-for="(item, index) of GLOBAL.selectMapOther" :key="index" @click="onClickOptionalItemInOther('item', item, index)">{{ item.name }}</div>
      </div>
      <div style="width: 100%;text-align: center;padding: 0 0 10px;">
        <el-button style="width: 20%;margin:10px auto 0;font-size: 13px;" type="primary" @click="handleSaveInOther">保存</el-button>
      </div>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import {EventBus} from '../common/eventBus'

export default {
  name: 'HeaderDjkx',
  data () {
    return {
      date: '连接中',
      status: '--'
    }
  },
  created () {
    if (localStorage.selectMapOther !== undefined) {
      this.GLOBAL.selectMapOther = JSON.parse(localStorage.selectMapOther)
    }
    if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
      this.connectWebSocket()
    }
    EventBus.$on('dateUpdated', updatedDate => {
      this.date = updatedDate
    })
    EventBus.$on('statusUpdated', updatedStatus => {
      this.status = updatedStatus
    })
  },
  beforeDestroy () {
  },
  mounted () {
  },
  methods: {
    handleSelfSelectInOther () {
      this.handleSelfSelectOther()
    },
    onClickOptionalItemInOther (type, item, index) {
      this.onClickOptionalItemOther(type, item, index)
    },
    handleSaveInOther () {
      this.handleSaveOther()
    }
  }
}
</script>

<style>
.el-dialog {
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderDjkxTv.vue